import { render, staticRenderFns } from "./MetRiportItemDetails.vue?vue&type=template&id=2bd1a06a&scoped=true&"
import script from "./MetRiportItemDetails.vue?vue&type=script&lang=ts&"
export * from "./MetRiportItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./MetRiportItemDetails.vue?vue&type=style&index=0&id=2bd1a06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1a06a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSpacer,VSwitch})
